import { Session } from 'acast-reactor';

/**
 * Create our reactor session. For create we will not do server-side rendering
 * but will still use the reactor module to perform queries so we will create
 * an empty session.
 */
export default Session.create('create-client-session', {
  queries: {},
});
